<template>
  <div>
    <div
      class="modal fade order-placed"
      id="`AlertModalPlaced`"
      tabindex="-1"
      aria-labelledby="AlertModalLabel"
      aria-hidden="true"
      ref="AlertModal"
      style="z-index: 9999"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div
          class="modal-content"
          :class="DisplayAlertData.isSetClass && DisplayAlertData.isSetClass"
        >
          <div
            class="modal-header"
            v-if="
              DisplayAlertData.isSetClass &&
              DisplayAlertData.isSetClass == 'prdct-modal-cls'
            "
          >
            <h5 class="modal-title">{{ $t("Clear Cart") }}?</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <!-- <span aria-hidden="true">&times;</span> -->
              <svg
                fill="#000000"
                width="25px"
                height="25px"
                viewBox="0 0 32 32"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM21.657 10.344c-0.39-0.39-1.023-0.39-1.414 0l-4.242 4.242-4.242-4.242c-0.39-0.39-1.024-0.39-1.415 0s-0.39 1.024 0 1.414l4.242 4.242-4.242 4.242c-0.39 0.39-0.39 1.024 0 1.414s1.024 0.39 1.415 0l4.242-4.242 4.242 4.242c0.39 0.39 1.023 0.39 1.414 0s0.39-1.024 0-1.414l-4.242-4.242 4.242-4.242c0.391-0.391 0.391-1.024 0-1.414z"
                  ></path>
                </g>
              </svg>
            </button>
          </div>
          <div
            class="modal-header"
            v-if="
              DisplayAlertData.isSetClass &&
              DisplayAlertData.isSetClass == 'addrs-modal-cls'
            "
          >
            <h5 class="modal-title">{{ $t("Address") }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <!-- <span aria-hidden="true">&times;</span> -->
              <svg
                fill="#000000"
                width="25px"
                height="25px"
                viewBox="0 0 32 32"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM21.657 10.344c-0.39-0.39-1.023-0.39-1.414 0l-4.242 4.242-4.242-4.242c-0.39-0.39-1.024-0.39-1.415 0s-0.39 1.024 0 1.414l4.242 4.242-4.242 4.242c-0.39 0.39-0.39 1.024 0 1.414s1.024 0.39 1.415 0l4.242-4.242 4.242 4.242c0.39 0.39 1.023 0.39 1.414 0s0.39-1.024 0-1.414l-4.242-4.242 4.242-4.242c0.391-0.391 0.391-1.024 0-1.414z"
                  ></path>
                </g>
              </svg>
            </button>
          </div>
          <div class="modal-body text-center">
            <p class="mt-3 mb-1" v-if="DisplayAlertData.displayMessage">
              <span
                v-html="DisplayAlertData.displayMessage"
                class="currency"
              ></span>
            </p>
          </div>
          <div class="modal-footer full-btn d-block">
            <a
              href="javascript:void(0);"
              @click="confirm('yes')"
              data-dismiss="modal"
              v-if="DisplayAlertData.isSetClass == 'schedule-modal'"
              >{{ $t("Schedule") }}</a
            >
            <a
              href="javascript:void(0);"
              @click="confirm('ok')"
              data-dismiss="modal"
              v-else-if="DisplayAlertData.isSetClass == 'placeorder-modal-cls'"
              >{{ $t("OK") }}</a
            >
            <a
              href="javascript:void(0);"
              @click="confirm('yes')"
              data-dismiss="modal"
              v-else
              >{{ $t("OK") }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  props: ["DisplayAlertData"],
  data() {
    return {
      isConfirm: "",
    };
  },
  mounted() {
    window.$(this.$refs.AlertModal).modal();
    $(this.$refs.AlertModal).on("hidden.bs.modal", this.oncloseModle);
  },
  methods: {
    confirm(val) {
      this.isConfirm = val;
    },

    oncloseModle(val) {
      this.$emit("modalClose", this.isConfirm);
    },
  },
};
</script>
